import dayjs from './dates';
import { InstructorLesson } from '../types';

/**
 * État d'émargement d'une leçon, dérivé du statut + de l'horaire + de la
 * présence signée. Remplace l'idée « toute leçon passée est réalisée ».
 */
export type LessonState = 'cancelled' | 'honored' | 'noshow' | 'upcoming';

export function lessonState(lesson: {
  status: string;
  endsAt: string;
  honored: boolean;
}): LessonState {
  if (lesson.status === 'cancelled') return 'cancelled';
  if (lesson.honored) return 'honored';
  if (dayjs().isAfter(dayjs(lesson.endsAt))) return 'noshow';
  return 'upcoming';
}

/** La leçon a commencé (l'élève est censé être présent → émargement possible). */
export function hasStarted(lesson: { startsAt: string }): boolean {
  return dayjs().isAfter(dayjs(lesson.startsAt));
}

export const STATE_CHIP: Record<
  LessonState,
  { label: string; className: string }
> = {
  honored: {
    label: 'Honorée',
    className: 'bg-green-50 text-green-700 border-green-200',
  },
  noshow: {
    label: 'Non honorée',
    className: 'bg-red-50 text-red-700 border-red-200',
  },
  cancelled: {
    label: 'Annulée',
    className: 'bg-slate-100 text-slate-500 border-slate-200',
  },
  upcoming: {
    label: 'Planifiée',
    className: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  },
};

/** Émargement possible : leçon commencée, non annulée, non encore honorée. */
export function canSignAttendance(lesson: InstructorLesson): boolean {
  return (
    !lesson.isOpenSlot &&
    lesson.status !== 'cancelled' &&
    !lesson.honored &&
    !!lesson.candidateId &&
    hasStarted(lesson)
  );
}
